module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [(_vm.item.fullNumber) ? _c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_number"
    }
  }, [_vm._v("Numer umowy")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.item.fullNumber))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.date)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_data"
    }
  }, [_vm._v("Data zawarcia umowy")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.item.date),
      callback: function($$v) {
        _vm.$set(_vm.item, "date", $$v)
      },
      expression: "item.date"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.date) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.date))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.customer)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_customer"
    }
  }, [_vm._v("Klient")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.customersList,
      "emptyValue": "Wybierz klienta",
      "nameField": "fullName",
      "valueField": "@id",
      "isSearch": true
    },
    on: {
      "change": _vm.setupCommission
    },
    model: {
      value: (_vm.item.customer),
      callback: function($$v) {
        _vm.$set(_vm.item, "customer", $$v)
      },
      expression: "item.customer"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.customer) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_customer_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.customer))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.currency)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_currency"
    }
  }, [_vm._v("Waluta")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "x": "",
      "elements": _vm.currencyTypes,
      "emptyValue": "Wybierz walutę",
      "valueField": "@id",
      "nameField": "name"
    },
    on: {
      "change": _vm.setupBankAccount
    },
    model: {
      value: (_vm.item.currency),
      callback: function($$v) {
        _vm.$set(_vm.item, "currency", $$v)
      },
      expression: "item.currency"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.currency) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_currency_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.currency))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.commission)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_commission"
    }
  }, [_vm._v("Prowizja")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "_commission"
    },
    model: {
      value: (_vm.item.commission),
      callback: function($$v) {
        _vm.$set(_vm.item, "commission", $$v)
      },
      expression: "item.commission"
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.commission) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_commission_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.commission))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccount"
    }
  }, [_vm._v("Konto bankowe")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "_bankAccount"
    },
    model: {
      value: (_vm.item.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.item, "bankAccount", $$v)
      },
      expression: "item.bankAccount"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAdditionalBankAccount),
      expression: "showAdditionalBankAccount"
    }],
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccountAdditional"
    }
  }, [_vm._v("Dodatkowe konto bankowe")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "_bankAccountAdditional"
    },
    model: {
      value: (_vm.item.bankAccountAdditional),
      callback: function($$v) {
        _vm.$set(_vm.item, "bankAccountAdditional", $$v)
      },
      expression: "item.bankAccountAdditional"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccountAdditional) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccountAdditional_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccountAdditional))]) : _vm._e()], 1), _vm._v(" "), (_vm.item.status) ? _c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "element_status",
    class: _vm.item.status
  }, [_vm._v(_vm._s(_vm._f("translate")(_vm.item['status'])))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.comments),
      expression: "item.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.comments))]) : _vm._e()]), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0ce56a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/FormGeneral.vue
// module id = 849
// module chunks = 0